webpackJsonp([267908526538628],{

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 1/4/18
	 */
	var PartnerOfferings = function PartnerOfferings(_ref) {
	    var gridItems = _ref.gridItems;
	    return _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        gridItems.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { key: item.image, className: 'column is-4', style: { borderRadius: '2px' } },
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'has-text-centered' },
	                        _react2.default.createElement('img', { className: 'how-it-works-svg', alt: '', src: item.image })
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        item.subheader
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        item.text
	                    )
	                )
	            );
	        })
	    );
	};
	
	PartnerOfferings.propTypes = {
	    gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        image: _propTypes2.default.string,
	        subheader: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    }))
	};
	
	exports.default = PartnerOfferings;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Relatedlogos = function Relatedlogos() {
	    return _react2.default.createElement(
	        'section',
	        { className: 'related-logos' },
	        _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-4' },
	                _react2.default.createElement('img', { className: 'grey-logo', src: '/img/seia.png' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-4' },
	                _react2.default.createElement('img', { className: 'grey-logo', src: '/img/seia.png' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-4' },
	                _react2.default.createElement('img', { className: 'grey-logo', src: '/img/seia.png' })
	            )
	        )
	    );
	}; /**
	    * Created by vaibhav on 1/4/18
	    */
	exports.default = Relatedlogos;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.partnersAboutPageQuery = exports.PartnersAboutPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(39);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PartnerOfferings = __webpack_require__(172);
	
	var _PartnerOfferings2 = _interopRequireDefault(_PartnerOfferings);
	
	var _NavBar = __webpack_require__(14);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Relatedlogos = __webpack_require__(78);
	
	var _Relatedlogos2 = _interopRequireDefault(_Relatedlogos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartnersAboutPageTemplate = exports.PartnersAboutPageTemplate = function PartnersAboutPageTemplate(_ref) {
	    var title = _ref.title,
	        content = _ref.content,
	        contentComponent = _ref.contentComponent,
	        partnerofferings = _ref.partnerofferings,
	        heading = _ref.heading;
	
	    var PageContent = contentComponent || _Content2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_NavBar2.default, null),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-primary is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'column is-10 is-offset-1' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'section' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'title' },
	                                    title
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section ' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'section ' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'column' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content' },
	                                _react2.default.createElement(_PartnerOfferings2.default, { gridItems: partnerofferings.blurbs })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section partners' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-10 is-offset-1' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section' },
	                            _react2.default.createElement(PageContent, { className: 'content', content: content })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section proof' },
	            _react2.default.createElement(_Relatedlogos2.default, null)
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns is-centered' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section home-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'has-text-centered' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'has-text-weight-semibold is-size-2 has-text-centered' },
	                                    heading
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'buttons is-centered' },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        className: 'button is-large is-primary',
	                                        href: 'https://signup.commonenergy.us/' },
	                                    'Learn More'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	PartnersAboutPageTemplate.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    content: _propTypes2.default.string,
	    partnerofferings: _propTypes2.default.shape({
	        blurbs: _propTypes2.default.array
	    }),
	    contentComponent: _propTypes2.default.func
	};
	
	var PartnersAboutPage = function PartnersAboutPage(_ref2) {
	    var data = _ref2.data;
	    var post = data.markdownRemark;
	
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                post.frontmatter.meta_title
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description })
	        ),
	        _react2.default.createElement(PartnersAboutPageTemplate, {
	            contentComponent: _Content.HTMLContent,
	            title: post.frontmatter.title,
	            partnerofferings: post.frontmatter.partnerofferings,
	            heading: post.frontmatter.heading,
	            content: post.html
	        })
	    );
	};
	
	PartnersAboutPage.propTypes = {
	    data: _propTypes2.default.object.isRequired
	};
	
	exports.default = PartnersAboutPage;
	var partnersAboutPageQuery = exports.partnersAboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-partners-about-page-js-93af6937c311bbb7c41d.js